module.exports = __webpack_public_path__ + "images/6efbe2c5952d38718f53c50533c92a01-TULUM-WHITE.png";